import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/apiService';

const RegistrationForm = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [tenantName, setTenantName] = useState('');
  const [newTenantName, setNewTenantName] = useState('');
  const [tenants, setTenants] = useState([]);
  const [roles, setRoles] = useState([]);
  const [selectedRoleId, setSelectedRoleId] = useState(null);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [mobile, setMobile] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    const fetchRolesAndTenants = async () => {
      try {
        const rolesRes = await api.get('/roles');
        setRoles(rolesRes.data);
        if (rolesRes.data.length > 0) {
          setSelectedRoleId(rolesRes.data[0].id);
        }

        const tenantsRes = await api.get('/auth/tenants');
        setTenants(tenantsRes.data);
        if (tenantsRes.data.length > 0) {
          setTenantName(tenantsRes.data[0].name);
        }
      } catch (err) {
        console.error('Fehler beim Laden:', err);
      }
    };
    fetchRolesAndTenants();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        username,
        password,
        tenantName: tenantName === '__new__' ? newTenantName : tenantName,
        roleId: selectedRoleId,
        firstName,
        lastName,
        email: email.trim() === '' ? null : email.trim(),
        phone,
        mobile
      };
      const response = await api.post('/auth/register', payload);
      alert('Registrierung erfolgreich: ' + JSON.stringify(response.data));
      navigate('/');
    } catch (error) {
      console.error('Registrierung fehlgeschlagen:', error);
      alert('Registrierung fehlgeschlagen.');
    }
  };

  return (
    <div>
      <h2>Registrierung</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Benutzername:</label>
          <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} required />
        </div>
        <div>
          <label>Passwort:</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        <div>
          <label>Tenant:</label>
          <select value={tenantName} onChange={e => setTenantName(e.target.value)}
           required>
            <option value="">-- Bitte wählen --</option>
            {tenants.map((t) => (
              <option key={t.id} value={t.name}>{t.name}</option>
            ))}
            <option value="__new__">+ Neuer Tenant...</option>
          </select>
        </div>
        {tenantName === '__new__' && (
          <div>
            <label>Neuer Tenant-Name:</label>
            <input
              type="text"
              value={newTenantName}
              onChange={(e) => setNewTenantName(e.target.value)}
              required
            />
          </div>
        )}
        <div>
          <label>Vorname:</label>
          <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
        </div>
        <div>
          <label>Nachname:</label>
          <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} />
        </div>
        <div>
          <label>E-Mail:</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div>
          <label>Telefon:</label>
          <input type="text" value={phone} onChange={(e) => setPhone(e.target.value)} />
        </div>
        <div>
          <label>Mobil:</label>
          <input type="text" value={mobile} onChange={(e) => setMobile(e.target.value)} />
        </div>
        <div>
          <label>Rolle:</label>
          <select value={selectedRoleId || ''} onChange={e => setSelectedRoleId(parseInt(e.target.value, 10))}>
            {roles.map((role) => (
              <option key={role.id} value={role.id}>{role.name}</option>
            ))}
          </select>
        </div>
        <button type="submit">Registrieren</button>
      </form>
    </div>
  );
};

export default RegistrationForm;
